import React, { useState, useEffect } from 'react';
import SubCard from 'ui-component/cards/SubCard';
import {
  Grid,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormHelperText,
  Alert,
  Snackbar,
  FormControl,
  Button,
  OutlinedInput,
  TextField
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { AddUser, EmployeeUser, ViewDepartment } from 'API/HrModule';
import { DataGrid } from '@mui/x-data-grid';
import { IoMdArrowBack } from 'react-icons/io';
// import AddIcon from '@mui/icons-material/Add';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ViewModal from './ViewModal';

const Index = () => {
  const [Input, setInput] = useState({});
  const [errors, setErrors] = useState({});
  const emailRegex = /^[^\s@.][^\s@]*@[^\s@]+\.[^\s@]+[^.]$/;
  const [Success, setSuccess] = useState(false);
  const [Error, setError] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [DepartmentData, setDepartmentData] = useState('');
  const [EmployeeOnboarding, setEmployeeOnboarding] = useState(false);
  const [Filter, setFilter] = useState({});
  const [EmployeeData, setEmployeeData] = useState([]);
  const [page, setPage] = useState(0); // Current page (starts from 0)
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [TotalCount, setTotalCount] = useState('');

  const [ViewOpen, setViewOpen] = useState({ open: false, data: null, type: null });

  const handleViewOpen = (data, type) => {
    setViewOpen({ open: true, data: data, type: type });
  };

  const handleViewClose = () => {
    setViewOpen({ open: false, data: null, type: null });
  };

  const [data, setData] = useState([
    {
      id: 'employee_code',
      name: 'Employee Code',
      type: 'text',
      regex: /^[a-zA-Z0-9][a-zA-Z0-9]*$/,
      required: true
    },
    {
      id: 'username',
      name: 'Full Name',
      type: 'text',
      regex: /^[a-zA-Z][a-zA-Z\s]*$/,
      required: true
    },
    {
      id: 'mobile_no',
      name: 'Mobile Number',
      type: 'text',
      regex: /^[6789]\d{0,9}$/,
      required: true
    },
    {
      id: 'department_id',
      name: 'Department',
      type: 'select',
      list: [],
      required: true
    },
    {
      id: 'designation_id',
      name: 'Designation',
      type: 'select',
      list: [],
      required: true
    },
    {
      id: 'email_id',
      name: 'Work Email ID',
      type: 'email',
      regex: emailRegex,
      required: true
    },
    {
      id: 'date_of_joining',
      name: 'Date of Joining',
      type: 'date',
      // regex: emailRegex,
      required: true
    }
  ]);
  const handleChangeFilter = (name, value) => {
    setFilter((prevInput) => ({
      ...prevInput,
      [name]: value
    }));
  };
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z0-9]/g, '');
  };
  const handlenameInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z\s]/g, '');
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'employee_code',
      headerName: 'Employee Code',
      width: 150
    },
    {
      field: 'username',
      headerName: 'Full Name',
      width: 150
    },
    {
      field: 'mobile_number',
      headerName: 'Mobile Number',
      type: 'text',
      width: 120
    },
    {
      field: 'department_id',
      headerName: 'Department',
      type: 'text',
      width: 150
    },
    {
      field: 'designation_id',
      headerName: 'Designation',
      type: 'text',
      width: 150
    },
    {
      field: 'emailid',
      headerName: 'Email',
      type: 'text',
      width: 200
    },
    {
      field: 'date_of_joining',
      headerName: 'Date of Joining',
      type: 'text',
      width: 170
    },
    {
      field: 'user_role',
      headerName: 'User Role',
      type: 'text',
      renderCell: (params) =>
        params.row.user_roles && Array.isArray(params.row.user_roles) && params.row.user_roles.length > 0 ? (
          <Button
            variant="outlined"
            color="secondary"
            sx={{
              borderColor: '#592375',
              color: '#592375',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#592375'
              }
            }}
            onClick={() => handleViewOpen(params.row, 'view')}
          >
            View
          </Button>
        ) : (
          <Button
            variant="outlined"
            color="secondary"
            sx={{
              borderColor: '#592375',
              color: '#592375',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#592375'
              }
            }}
            onClick={() => handleViewOpen(params.row, 'select')}
          >
            Select
          </Button>
        ),
      width: 170
    },
    {
      field: 'action',
      headerName: 'Action',
      type: 'text',
      width: 200,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="secondary"
          disabled={params.row.user_roles && Array.isArray(params.row.user_roles) && params.row.user_roles.length > 0 ? false : true}
          sx={{
            borderColor: '#592375',
            color: '#592375',
            borderRadius: '6px',
            '&:hover': {
              borderColor: '#592375'
            }
          }}
          onClick={() => handleViewOpen(params.row, 'edit')}
        >
          Edit
        </Button>
      )
    }
  ];

  const rows =
    EmployeeData && Array.isArray(EmployeeData)
      ? EmployeeData.map((item) => ({
          id: item._id,
          username: item.username ? item.username : '-',
          employee_code: item.employee_code ? item.employee_code : '-',
          mobile_number: item.mobile_number ? item.mobile_number : '-',
          department_id: item.department_id ? item.department_id : '-',
          designation_id: item.designation_id ? item.designation_id : '-',
          emailid: item.emailid ? item.emailid : '-',
          date_of_joining: item.date_of_joining ? formatDate(item.date_of_joining) : '-',
          user_roles: item.user_roles ? item.user_roles : []
        }))
      : [];

  const handleChange = (name, value) => {
    if (name === 'department_id') {
      setInput((prevInput) => ({
        ...prevInput,
        [name]: value,
        designation_id: ''
      }));

      // You also need to update the designation list when department changes
      const selectedDept = DepartmentData.find((dept) => dept._id === value);
      setData((prevData) =>
        prevData.map((item) => (item.id === 'designation_id' ? { ...item, list: selectedDept?.designations || [] } : item))
      );
    } else {
      setInput((prevInput) => ({
        ...prevInput,
        [name]: value
      }));
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value && typeof value === 'string' && value.trim() !== '' && updatedErrors[name]) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const validateForm = () => {
    const newErrors = {};

    data.forEach((item) => {
      const value = Input[item.id];

      if (!value || (typeof value === 'string' && value.trim() === '')) {
        newErrors[item.id] = `${item.name} is required`;
      }
      if (item.id === 'mobile_no') {
        if (!value || value.length !== 10 || !item.regex.test(value)) {
          newErrors[item.id] = 'Please enter a valid 10-digit mobile number';
        }
      }

      if (item.type === 'email' && item.regex && !item.regex.test(value)) {
        newErrors[item.id] = 'Please enter a valid email address';
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      // Form is valid, submit data
      AddUser(Input, setIsLoading, setSuccess, setError, setInput, refunction, setEmployeeOnboarding);
    }
  };

  useEffect(() => {
    ViewDepartment(setIsLoading, setDepartmentData, setError);
  }, []);

  useEffect(() => {
    if (DepartmentData && DepartmentData.length) {
      setData((prevData) =>
        prevData.map((item) => {
          if (item.id === 'department_id') {
            return { ...item, list: DepartmentData }; // assign full object list
          }
          return item;
        })
      );
    }
  }, [DepartmentData]);
  const isFilterEmpty = Object.values(Filter).every((val) => val === '');

  const handleClear = () => {
    setFilter({ employee_code: '', name: '' });
    // EmployeeUser(page + 1, rowsPerPage, { employee_code: '', name: '' }, setEmployeeData, setIsLoading, setError, setTotalCount);
  };

  const handleGet = () => {
    EmployeeUser(1, rowsPerPage, Filter, setEmployeeData, setIsLoading, setError, setTotalCount);
    setPage(0); // Reset to first page
    setRowsPerPage(5); // Reset to default rows per page
  };
  const refunction = () => {
    EmployeeUser(page + 1, rowsPerPage, Filter, setEmployeeData, setIsLoading, setError, setTotalCount);
  };

  useEffect(() => {
    EmployeeUser(page + 1, rowsPerPage, Filter, setEmployeeData, setIsLoading, setError, setTotalCount);
  }, [page, rowsPerPage, Filter]);

  return (
    <>
      {/* <Backdrop open={IsLoading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <CircularProgress color="inherit" />
          </Backdrop> */}
      <ViewModal open={ViewOpen.open} data={ViewOpen.data} type={ViewOpen.type} handleClose={handleViewClose} handleGet={handleGet} />
      <Snackbar
        open={Error}
        autoHideDuration={5000}
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setError(false)} variant="filled" severity="error" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Success}
        autoHideDuration={5000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setSuccess(false)} variant="filled" severity="success" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      <SubCard title="Employee Onboarding" sx={{ height: 'auto' }}>
        {EmployeeOnboarding ? (
          <>
            <Grid container spacing={2}>
              <Button
                sx={{ width: '20px', ml: 2 }}
                variant="outlined"
                color="secondary"
                onClick={() => {
                  setEmployeeOnboarding(false);
                  setErrors([]);
                  setInput({
                    date_of_joining: '',
                    department_id: '',
                    designation_id: '',
                    email_id: '',
                    employee_code: '',
                    username: '',
                    mobile_no: ''
                  });
                }}
              >
                <IoMdArrowBack style={{ fontSize: '20px' }} />
              </Button>
              <Grid item xl={12} md={12} sm={12}>
                <Grid container spacing={2}>
                  {data.map((item, index) => (
                    <Grid item xl={4} md={4} sm={6} xs={12} key={index}>
                      {item.type === 'text' && (
                        <FormControl fullWidth>
                          <InputLabel required={item.required}>{item.name} </InputLabel>
                          <OutlinedInput
                            label={item.name}
                            required={item.required}
                            placeholder={item.placeholder}
                            value={Input[item.id]}
                            // onInput={(e) => {
                            //   if (item.regex && !item.regex.test(e.target.value)) {
                            //     e.target.value = e.target.value.slice(0, -1);
                            //   }
                            // }}
                            onInput={(e) => {
                              const val = e.target.value;

                              if (item.regex && !item.regex.test(val)) {
                                e.target.value = val.slice(0, -1);
                              }
                            }}
                            onChange={(e) => handleChange(item.id, e.target.value)}
                            // startAdornment={
                            //   item.id === 'purchase_price' || item.id === 'amount' ? <InputAdornment position="start">₹</InputAdornment> : ''
                            // }
                            // endAdornment={item.id === 'warranty' ? <InputAdornment position="end">years</InputAdornment> : ''}
                            error={Boolean(errors[item.id])}
                            inputProps={{
                              maxLength: item.id === 'mobile_no' ? 10 : item.id === 'employee_code' ? 8 : undefined
                            }}
                          />
                          {errors[item.id] && (
                            <FormHelperText error id="standard-weight-helper-text--register">
                              {errors[item.id]}
                            </FormHelperText>
                          )}
                        </FormControl>
                      )}
                      {item.type === 'select' && (
                        <FormControl fullWidth>
                          <InputLabel required={item.required}>{item.name} </InputLabel>
                          <Select
                            label={item.name}
                            required={item.required}
                            // onChange={(e) => handleChange(item.id, e.target.value)}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              handleChange(item.id, selectedId); // send _id
                              if (item.id === 'department_id') {
                                const selectedDept = item.list.find((d) => d._id === selectedId);

                                setData((prevData) =>
                                  prevData.map((field) =>
                                    field.id === 'designation_id' ? { ...field, list: selectedDept?.designations || [] } : field
                                  )
                                );
                              }
                            }}
                            error={Boolean(errors[item.id])}
                            // disabled={item.id === 'designation_id' && !Input['department_id']}
                            helperText={errors[item.id]}
                            value={Input[item.id] || 'select'}
                            inputProps={{
                              readOnly: item.id === 'designation_id' && !Input['department_id']
                            }}
                          >
                            <MenuItem value={'select'} disabled>
                              Select
                            </MenuItem>
                            {item.list &&
                              item.list.map((value, index) => (
                                <MenuItem value={value._id} key={index}>
                                  {value.name}
                                </MenuItem>
                              ))}
                            {/* <MenuItem value={'deactivate'}>Deactivate</MenuItem> */}
                          </Select>
                          {/* {errors[item.id] && <h5 style={{ color: 'red', margin: '5px 0', fontWeight: '400' }}>{errors[item.id]}</h5>} */}
                          {errors[item.id] && (
                            <Typography variant="subtitle2" display={errors[item.id] ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                              {errors[item.id]}
                            </Typography>
                          )}
                        </FormControl>
                      )}
                      {item.type === 'email' && (
                        <FormControl fullWidth>
                          <InputLabel required={item.required}>{item.name} </InputLabel>
                          <OutlinedInput
                            label={item.name}
                            required={item.required}
                            onChange={(e) => handleChange(item.id, e.target.value)}
                            fullWidth
                            placeholder="name@mail.com"
                            value={Input[item.id]}
                            error={Boolean(errors[item.id])}
                            helperText={errors[item.id]}
                          />
                          {errors[item.id] && (
                            <Typography variant="subtitle2" display={errors[item.id] ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                              {errors[item.id]}
                            </Typography>
                          )}
                        </FormControl>
                      )}
                      {item.type === 'date' && (
                        <FormControl fullWidth>
                          <TextField
                            label={item.name}
                            required={item.required}
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            value={Input[item.id] || ''}
                            onChange={(e) => handleChange(item.id, e.target.value)}
                            error={Boolean(errors[item.id])}
                            helperText={errors[item.id]}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              inputProps: {
                                min: '1950-01-01',
                                max: new Date().toISOString().split('T')[0]
                              }
                            }}
                            fullWidth
                          />
                        </FormControl>
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
            <Grid container mt={2} mb={2} justifyContent="center">
              <Grid item xl={3} mt={2}>
                <LoadingButton
                  loading={IsLoading}
                  variant="contained"
                  sx={{
                    width: '250px',
                    backgroundColor: '#592375',
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#592375'
                    }
                  }}
                  color="secondary"
                  onClick={handleSubmit}
                >
                  submit
                </LoadingButton>
              </Grid>
              {/* </div> */}
            </Grid>
          </>
        ) : (
          <>
            <Grid container spacing={2} mb={2} alignItems="center">
              <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                <FormControl fullWidth>
                  <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                    Employee Code
                  </Typography>
                  <TextField
                    // label="Employee Code"
                    value={Filter.employee_code}
                    size="small"
                    onInput={handleInput}
                    name="employee_code"
                    onChange={(e) => handleChangeFilter('employee_code', e.target.value)}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                <FormControl fullWidth>
                  <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                    Name
                  </Typography>
                  <TextField
                    // label="Name"
                    onInput={handlenameInput}
                    size="small"
                    name="name"
                    value={Filter.name}
                    onChange={(e) => handleChangeFilter('name', e.target.value)}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={2} md={2} lg={2} xl={2} mt={3}>
                <Button
                  color="secondary"
                  size="small"
                  variant="contained"
                  sx={{
                    backgroundColor: '#592375',
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#592375'
                    }
                  }}
                  disabled={isFilterEmpty}
                  onClick={handleClear}
                >
                  Clear
                </Button>
              </Grid>

              <Grid item xs={12} sm={4} md={4} lg={3} xl={3} mt={3} display="flex" justifyContent="flex-end">
                <Button
                  fullWidth
                  color="secondary"
                  variant="contained"
                  sx={{
                    backgroundColor: '#688B2A',
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#688B2A'
                    }
                  }}
                  endIcon={<AddCircleIcon />}
                  onClick={() => setEmployeeOnboarding(true)}
                >
                  Employee Onboarding
                </Button>
              </Grid>
            </Grid>

            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                    page: 0
                  }
                }
              }}
              sx={{
                '& .MuiDataGrid-columnHeaders': {
                  color: '#592375'
                }
              }}
              autoHeight
              pageSizeOptions={[5, 50, 100]}
              paginationMode="server"
              rowCount={TotalCount}
              onPaginationModelChange={(paginationModel) => {
                setPage(paginationModel.page);
                setRowsPerPage(paginationModel.pageSize);
              }}
              getRowId={(row) => row.id}
              loading={IsLoading}
              disableRowSelectionOnClick
            />
          </>
        )}
      </SubCard>
    </>
  );
};

export default Index;
